@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Brand Header -->
<div
  class="relative mb-4 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between flex-wrap gap-2 px-5 py-3 relative"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Secondary Trip Coverage Analytics
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Actions -->
    <div class="relative flex items-center flex-wrap" style="gap: 8px">
      <span class="text-xs font-medium" style="color: #64748b"
        >Last Refreshed:
        <span style="color: #0f766e; font-weight: 600">{{
          refresh_tm
        }}</span></span
      >
      <label style="font-size: 12px; font-weight: 600; color: #64748b"
        >Date:</label
      >
      <nz-date-picker
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="slctdDt"
        (ngModelChange)="onChange($event)"
        style="border-radius: 6px; width: 150px"
      >
      </nz-date-picker>
      <button
        (click)="refresh()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="
          background: linear-gradient(135deg, #0f766e, #115e59);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(15, 118, 110, 0.3);
        "
      >
        <span nz-icon nzType="reload" nzTheme="outline"></span>
        Refresh
      </button>
    </div>
  </div>
</div>

<div class="mx-auto px-3">
  <!-- ═══════════════════════════════════════════════════════ -->
  <!-- Summary Cards                                           -->
  <!-- ═══════════════════════════════════════════════════════ -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div>
    @for (d of tdyCoveredTrips; track d; let first = $first) { @if (first) {
    <!-- Overview Row: Trip Overview | Route Status | Coverage -->
    <div class="ds-overview-row ds-section">
      <!-- Trip Overview -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-blue">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
              ></path>
            </svg>
            <span class="ds-container-title">Trip Overview</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-4">
            <div class="ds-card ds-neutral">
              <div class="ds-value">
                {{ d.TOT_VEHICLES === null ? "0" : d.TOT_VEHICLES }}
              </div>
              <div class="ds-label">Total Vehicles</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-teal"
                  [style.width.%]="100"
                ></div>
              </div>
            </div>
            <div class="ds-card ds-info">
              <div class="ds-value" style="color: #1e40af">
                {{ d.TOTAL_TRIPS === null ? "0" : d.TOTAL_TRIPS }}
              </div>
              <div class="ds-label">Total Trips</div>
              <span class="ds-pct ds-pct-blue">100%</span>
            </div>
            <div class="ds-card ds-positive">
              <div class="ds-value ds-green">
                {{ d.OPERATED === null ? "0" : d.OPERATED }}
              </div>
              <div class="ds-label">Completed</div>
              <span class="ds-pct ds-pct-green"
                >{{
                  (d.TOTAL_TRIPS || 0) > 0
                    ? (((d.OPERATED || 0) / (d.TOTAL_TRIPS || 1)) * 100
                      | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-negative">
              <div class="ds-value ds-red">
                {{ d.NOT_TRAVELLED === null ? "0" : d.NOT_TRAVELLED }}
              </div>
              <div class="ds-label">Not Travelled</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (d.TOTAL_TRIPS || 0) > 0
                    ? (((d.NOT_TRAVELLED || 0) / (d.TOTAL_TRIPS || 1)) * 100
                      | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Route Status -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-amber">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
              ></path>
            </svg>
            <span class="ds-container-title">Route Status</span>
          </div>
        </div>
        @if (ttlTrpsCnt && ttlTrpsCnt.length > 0) {
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-3">
            <div class="ds-card ds-neutral">
              <div class="ds-value">{{ ttlTrpsCnt[0].def_trps || 0 }}</div>
              <div class="ds-label">Total Routes</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-amber"
                  [style.width.%]="100"
                ></div>
              </div>
            </div>
            <div class="ds-card ds-positive">
              <div class="ds-value ds-green">
                {{ ttlTrpsCnt[0].rts_dfnd || 0 }}
              </div>
              <div class="ds-label">Defined</div>
              <span class="ds-pct ds-pct-green"
                >{{
                  (ttlTrpsCnt[0].def_trps || 0) > 0
                    ? (((ttlTrpsCnt[0].rts_dfnd || 0) /
                        (ttlTrpsCnt[0].def_trps || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-negative">
              <div class="ds-value ds-red">
                {{ ttlTrpsCnt[0].rts_not_dfnd || 0 }}
              </div>
              <div class="ds-label">Not Defined</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (ttlTrpsCnt[0].def_trps || 0) > 0
                    ? (((ttlTrpsCnt[0].rts_not_dfnd || 0) /
                        (ttlTrpsCnt[0].def_trps || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
        } @if (!ttlTrpsCnt || ttlTrpsCnt.length === 0) {
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-3">
            <div class="ds-card ds-neutral">
              <div class="ds-value">0</div>
              <div class="ds-label">Total Routes</div>
            </div>
            <div class="ds-card ds-positive">
              <div class="ds-value ds-green">0</div>
              <div class="ds-label">Defined</div>
            </div>
            <div class="ds-card ds-negative">
              <div class="ds-value ds-red">0</div>
              <div class="ds-label">Not Defined</div>
            </div>
          </div>
        </div>
        }
      </div>
      <!-- Coverage -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-teal">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
              ></path>
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
              ></path>
            </svg>
            <span class="ds-container-title">Coverage</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-1">
            <div class="ds-card ds-info">
              <div class="ds-value" style="color: #0f766e">
                {{ d.trvl_dist === null ? "0" : d.trvl_dist }}
              </div>
              <div class="ds-label">Distance (KM)</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-teal"
                  [style.width.%]="100"
                ></div>
              </div>
            </div>
            <div
              class="ds-card"
              [ngClass]="(avg_cvrg || 0) >= 50 ? 'ds-positive' : 'ds-negative'"
            >
              <div
                class="ds-value"
                [style.color]="(avg_cvrg || 0) >= 50 ? '#059669' : '#dc2626'"
              >
                {{ avg_cvrg === null ? 0 : avg_cvrg }}%
              </div>
              <div class="ds-label">Avg Coverage</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill"
                  [ngClass]="(avg_cvrg || 0) >= 50 ? 'fill-green' : 'fill-red'"
                  [style.width.%]="avg_cvrg || 0"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } }
  </div>
  }

  <!-- ═══════════════════════════════════════════════════════ -->
  <!-- ULB wise Coverage Table                                 -->
  <!-- ═══════════════════════════════════════════════════════ -->
  <div
    class="bg-white rounded-lg mb-4 overflow-hidden cvrg-grid-section"
    style="border: 1px solid #e5e7eb; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05)"
  >
    <!-- Table Header -->
    <div
      class="flex items-center justify-between gap-2 px-4 py-2.5"
      style="border-bottom: 1px solid #f1f5f9"
    >
      <div class="flex items-center gap-2">
        <div
          class="flex items-center justify-center"
          style="
            width: 28px;
            height: 28px;
            background: #f1f5f9;
            border-radius: 6px;
          "
        >
          <svg
            style="width: 14px; height: 14px; color: #475569"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
            ></path>
          </svg>
        </div>
        <span
          style="
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          "
          >ULB wise Coverage Status</span
        >
      </div>
    </div>

    <app-data-grid
      [legacyTotalItems]="ttlColumnDefs"
      id="gridContainer"
      style="width: 100%"
      [dataSource]="tripsData"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="false"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="Zone wise Trip Coverage Status"
      [pageSize]="10"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="false"
      (cellClick)="devCellclk(columnDefs, $event)"
      [cellPrepared]="bound_onCellPrepared"
    >
    </app-data-grid>
  </div>

  <!-- ═══════════════════════════════════════════════════════ -->
  <!-- Chart Row                                               -->
  <!-- ═══════════════════════════════════════════════════════ -->
  <div class="chart-row mt-4">
    <div class="chart-col">
      <div
        class="bg-white rounded-lg overflow-hidden chart-card"
        style="
          border: 1px solid #e5e7eb;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
        "
      >
        <div
          class="flex items-center gap-2 px-4 py-2.5"
          style="border-bottom: 1px solid #f1f5f9"
        >
          <div
            class="flex items-center justify-center"
            style="
              width: 28px;
              height: 28px;
              background: #f1f5f9;
              border-radius: 6px;
            "
          >
            <svg
              style="width: 14px; height: 14px; color: #475569"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              ></path>
            </svg>
          </div>
          <span
            style="
              font-size: 14px;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.3px;
            "
            >Coverage in Last 7 Days</span
          >
        </div>
        <div id="coverageChart"></div>
      </div>
    </div>
    <div class="chart-col">
      <div
        class="bg-white rounded-lg overflow-hidden chart-card"
        style="
          border: 1px solid #e5e7eb;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
        "
      >
        <div
          class="flex items-center justify-between gap-2 px-4 py-2.5"
          [style.border-bottom]="
            showTop10 ? '2px solid #059669' : '2px solid #e11d48'
          "
        >
          <div class="flex items-center gap-2">
            <div
              class="flex items-center justify-center"
              style="width: 28px; height: 28px; border-radius: 6px"
              [style.background]="showTop10 ? '#ecfdf5' : '#fff1f2'"
            >
              @if (showTop10) {
              <svg
                style="width: 14px; height: 14px; color: #059669"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 10l7-7m0 0l7 7m-7-7v18"
                ></path>
              </svg>
              } @if (!showTop10) {
              <svg
                style="width: 14px; height: 14px; color: #e11d48"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                ></path>
              </svg>
              }
            </div>
            <span
              style="
                font-size: 14px;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.3px;
              "
              [style.color]="showTop10 ? '#065f46' : '#9f1239'"
            >
              {{
                showTop10 ? "Top 10 ULB Coverages" : "Least 10 ULB Coverages"
              }}
            </span>
          </div>
          <div class="cvrg-toggle-btns">
            <button
              class="cvrg-toggle-btn"
              [class.cvrg-toggle-active-top]="showTop10"
              (click)="showTop10 = true"
            >
              <svg
                class="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 10l7-7m0 0l7 7m-7-7v18"
                ></path>
              </svg>
              Top 10
            </button>
            <button
              class="cvrg-toggle-btn"
              [class.cvrg-toggle-active-least]="!showTop10"
              (click)="showTop10 = false"
            >
              <svg
                class="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                ></path>
              </svg>
              Least 10
            </button>
          </div>
        </div>
        @if (showTop10) {
        <div class="top10-ulb-grid">
          <app-data-grid
            style="width: 100%"
            [dataSource]="top10UlbData"
            [legacyColumns]="top10UlbColumnDefs"
            [searchPanel]="false"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="true"
            exportFileName="Top 10 ULB Coverages"
            [pageSize]="10"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="false"
          >
          </app-data-grid>
        </div>
        } @if (!showTop10) {
        <div class="least10-ulb-grid">
          <app-data-grid
            style="width: 100%"
            [dataSource]="least10UlbData"
            [legacyColumns]="least10UlbColumnDefs"
            [searchPanel]="false"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="true"
            exportFileName="Least 10 ULB Coverages"
            [pageSize]="10"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="false"
          >
          </app-data-grid>
        </div>
        }
      </div>
    </div>
  </div>
</div>
